module.exports = __webpack_public_path__ + "static/media/background.3fc63480.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionOne/background.jpg
// module id = 147
// module chunks = 0